export default __webpack_public_path__ + "static/media/H_Forms.e4c2bdeb.png";